/*
 * ----------------------------------------------------------------------------
 * ZAHNHELD REVEAL FALLBACK AND THEME.JS RECOVERY
 * ----------------------------------------------------------------------------
 * theme.css hides `[reveal-js]`, `[reveal-on-scroll="true"]` and `reveal-items`
 * at opacity 0 (product tiles, section headings), and only the module script
 * theme.js ever fades them back in. If that module never runs, the page shows a
 * filter bar above an empty grid, and cart drawer, variant pickers and every
 * other Impact component are dead too. The `@media (scripting: none)` escape in
 * theme.css only covers JS switched off entirely, not this case.
 *
 * PostHog shows how it happens: theme.js imports the bare specifier "vendor",
 * and in some sessions that specifier is never resolved through the import map
 * ("The specifier 'vendor' was a bare specifier, but was not remapped"). Seen on
 * Firefox, on Safari up to 16.x and in iOS in-app browsers, which are exactly the
 * browsers Shopify serves its import-map polyfill (es-module-shims) to.
 *
 * This file is a CLASSIC script on purpose: it must keep running exactly when
 * the module graph does not. After DOMContentLoaded it waits GRACE_MS (native
 * modules have executed by then; the polyfill on old Safari can be later). If
 * `reveal-items` is still unregistered:
 *
 * 1. RECOVER. If theme.js never started (its very first statement registers
 *    `country-selector`) and the polyfill's `importShim` exists, theme.js is
 *    imported again through the polyfill, which resolves "vendor" from the
 *    page's own import map. The revived `reveal-items` then reveals the grid on
 *    its own. A theme.js that already started is NEVER re-run: a second run
 *    would register every document listener twice.
 * 2. REVEAL. Otherwise, or if the recovery fails or misses RECOVERY_MS, set
 *    `html.zh-reveal-fallback`; assets/zahnheld.css then shows the elements.
 *
 * Working browsers never reach either branch. Both outcomes are reported to
 * PostHog as `zh_theme_js_recovery` (when PostHog is loaded) to keep the
 * failure rate measurable.
 *
 * Tests: tests/zh-reveal-fallback.test.js.
 */
(function () {
  'use strict';

  var GRACE_MS = 3000;
  var RECOVERY_MS = 4000;
  var FALLBACK_CLASS = 'zh-reveal-fallback';
  var THEME_SCRIPT = 'script[type="module"][src*="/assets/theme.js"]';

  var defined = function (name) {
    return !!(window.customElements && window.customElements.get(name));
  };

  var report = function (outcome) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture('zh_theme_js_recovery', { outcome: outcome });
      }
    } catch (e) {
      // Reporting must never break the fallback itself.
    }
  };

  var settled = false;

  var showFallback = function (outcome) {
    if (settled) return;
    settled = true;
    document.documentElement.classList.add(FALLBACK_CLASS);
    report(outcome);
  };

  var finishRecovery = function () {
    if (settled) return;
    if (defined('reveal-items')) {
      settled = true;
      report('recovered');
    } else {
      showFallback('recovery_failed');
    }
  };

  var recover = function (src) {
    window.setTimeout(function () {
      showFallback('recovery_timeout');
    }, RECOVERY_MS);
    window.importShim(src).then(finishRecovery, function () {
      showFallback('recovery_failed');
    });
  };

  var check = function () {
    if (defined('reveal-items')) return;

    var script = document.querySelector(THEME_SCRIPT);
    var canRecover =
      !defined('country-selector') && typeof window.importShim === 'function' && script && script.src;

    if (canRecover) {
      recover(script.src);
    } else {
      showFallback('reveal_only');
    }
  };

  var arm = function () {
    window.setTimeout(check, GRACE_MS);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
})();
